export default __webpack_public_path__ + "static/media/c6842479-e0ee-49a2-9053-d00639074f7a_tick.6e4045be.gif";